import {Component, Input, OnInit} from '@angular/core'
import {OptionsNgxOwCarouselService} from 'dmmp-services'

@Component({
  selector: 'dmmp-banner',
  templateUrl: './banner.component.html'
})
export class BannerComponent implements OnInit {
  @Input() identifier
  @Input() data
  configCarousel
  content = []

  constructor(private options: OptionsNgxOwCarouselService) {
  }

  ngOnInit() {
    this.configCarousel = this.options.configurationBenefits(this.data)
    if (this.data?.content) {
      this.content = Object.values(this.data?.content)
    }
  }
}
